//* Display
//* the learner who submitted the lesson and
//* the marker who is assigned to the lesson.
//* in the header of the LessonPlayer in the 'mark' display mode.

import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import Typography from '@mui/material/Typography';
import styles from '../../styles/LessonPlayerUsersPanel.module.css';

interface LessonPlayerUsersPanelProps {
  learner: string;
  marker: string;
}

export function LessonPlayerUsersPanel(props: LessonPlayerUsersPanelProps) {
  return (
    <Grid container spacing={2}>
      <Grid>
        <Grid container direction="column">
          <Grid>
            <Typography variant="caption" className={styles.capitalize}>
              Submitted by
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="body2">{props.learner}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Grid container direction="column">
          <Grid>
            <Typography variant="caption" className={styles.capitalize}>
              Assigned for Marking
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="body2">{props.marker}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
